import Image from "next/image";
import Head from "next/head";
import styles from "./optional-test-series.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
// import Interest from "../../components/might-be-interest";
//import crashcourse from "../../assets/images/upsc/Forestry/Indian-Forest-Services-Exam-2024-WebBanner.jpg";
//import Mobcrashcourse from "../../assets/images/upsc/Forestry/Indian-Forest-Services-Exam-2024-MobileBanner.jpg";
import Link from "next/link";
import check from "../../assets/images/upsc/check.png";

const Two_Year_Classroom_Programme = () => {

    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>UPSC IFoS Optional Test Series 2024 | Shankar IAS Academy</title>
            <meta name="title" content="UPSC IFoS Optional Test Series 2024 | Shankar IAS Academy" />
            <meta name="description" content="Join our UPSC IFoS Optional Test Series 2024 for exam-like practice, instant feedback, and detailed analysis to enhance your IFoS exam preparation!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-ifos-optional-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UPSC IFoS Optional Test Series 2024 | Shankar IAS Academy" />
            <meta property="og:description" content="Join our UPSC IFoS Optional Test Series 2024 for exam-like practice, instant feedback, and detailed analysis to enhance your IFoS exam preparation!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-ifos-optional-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="upsc" />
        
        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-2">
                <h1 className={`${styles.pagemaintitle}`}>UPSC IFoS Optional Test Series 2024</h1>
            </div>
            </div>

           {/* <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={crashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

        <div className="row d-block d-md-none">
            <div className="col mb-3">
              <Image
                src={Mobcrashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div>
          </div> */}
        </div>
        
  

        {/* table */}
  <section className="pt-3 pb-3" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
        <div className="container">
           <div className=" col-xl-12 ">   
              <div className="row">
                  <div class=" col-12 col-md-12 col-lg-12 col-xl-12 d-none d-lg-block d-md-block">
                  
                         <table class="table table-striped">
                              <thead class="border-dark">
                                    <tr>
                                        <td className={`${styles.tableheading}`}>Optional Subject</td>
                                        <td className={`${styles.tableheading}`}>Mode</td>
                                        <td className={`${styles.tableheading}`}>Starts on<br/></td>
                                        <td className={`${styles.tableheading}`}>Fee<br/></td>
                                        <td className={`${styles.tableheading}`}>Schedule<br/></td>
                                        <td className={`${styles.tableheading}`}>Admission<br/></td>
                                    </tr>
                                </thead>
                               <tbody>
                                   
                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Agriculture</td>
                                        <td className={`${styles.tablepara}`}>Hybrid</td>
                                        <td className={`${styles.tablepara}`}>13th Oct 2024</td>
                                        <td className={`${styles.tablepara}`}> 6,500 (Old Students)<br/><p className={`${styles.tablepara}`}>7,000 (New Students)</p></td>
                                        <td className={`${styles.tablepara}`}><Link href="/pdf/Upsc-IFoS-2024/IFOS-Agriculture-Test-Schedule-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Forestry</td>
                                        <td className={`${styles.tablepara}`}>Hybrid</td>
                                        <td className={`${styles.tablepara}`}>28th Oct 2024</td>
                                        <td className={`${styles.tablepara}`}>5,000 </td>
                                        <td className={`${styles.tablepara}`}><Link href="/pdf/Upsc-IFoS-2024/IFOS-Forestry-Test-Schedule-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Geology </td>
                                        <td className={`${styles.tablepara}`}>Hybrid</td>
                                        <td className={`${styles.tablepara}`}>27th Oct 2024</td>
                                        <td className={`${styles.tablepara}`}> 6,500 (Old Students)<br/><p className={`${styles.tablepara}`}>7,000 (New Students)</p></td>
                                        <td className={`${styles.tablepara}`}><Link href="/pdf/Upsc-IFoS-2024/IFOS-Geology-Test-Schedule-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Mathematics</td>
                                        <td className={`${styles.tablepara}`}>Hybrid</td>
                                        <td className={`${styles.tablepara}`}>10th Oct 2024</td>
                                        <td className={`${styles.tablepara}`}> 8,000 (Old Students)<br/><p className={`${styles.tablepara}`}>8,000 (New Students)</p></td>
                                        <td className={`${styles.tablepara}`}><Link href="/pdf/Upsc-IFoS-2024/IFOS-Maths-Test-Schedule-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                              </tbody>
                        </table>
                        </div>
                  
                </div>
              </div>
        </div>
</section>

        {/* Mobile View */}

<section className=" pb-3 d-md-none" style={{background: "" , opacity: "1"}}>
    <div className="container mt-2 mb-5">
        <div className="col-12 col-xl-12 ">   
        <div className="row">
     
        <div class=" col-12 col-xl-12 d-block d-md-none" style={{backgroundColor:"#f4f6f8"}}>
          <div class="py-2" style={{backgroundColor: "#001e62"}}><h2 className={`${styles.tabletitle}`}>UPSC IFoS Optional Test Series 2024</h2></div>   

                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none"><b>Optional Subject</b></div>
                    <div class="col-6 pt-3 col-md-3">Agriculture</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Mode</b></div>
                    <div class="col-6 pt-3 col-md-3">Hybrid</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Starts on</b></div>
                    <div class="col-6 pt-3 col-md-3">13th Oct 2024</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Fee</b></div>
                    <div class="col-6 pt-3 col-md-3">6,500 (Old Students)<br/>7,000 (New Students)</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Upsc-IFoS-2024/IFOS-Agriculture-Test-Schedule-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 pb-2 d-block d-md-none"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-2 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none"><b>Optional Subject</b></div>
                    <div class="col-6 pt-3 col-md-3">Forestry</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Mode</b></div>
                    <div class="col-6 pt-3 col-md-3">Hybrid</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Starts on</b></div>
                    <div class="col-6 pt-3 col-md-3">28th  Oct 2024</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Fee</b></div>
                    <div class="col-6 pt-3 col-md-3">6,500 (Old Students)<br/>7,000 (New Students)</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Upsc-IFoS-2024/IFOS-Forestry-Test-Schedule-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 pb-2 d-block d-md-none"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-2 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none"><b>Optional Subject</b></div>
                    <div class="col-6 pt-3 col-md-3">Geology</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Mode</b></div>
                    <div class="col-6 pt-3 col-md-3">Hybrid</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Starts on</b></div>
                    <div class="col-6 pt-3 col-md-3">27th  Oct 2024</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Fee</b></div>
                    <div class="col-6 pt-3 col-md-3">6,500 (Old Students)<br/>7,000 (New Students)</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Upsc-IFoS-2024/IFOS-Geology-Test-Schedule-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 pb-2 d-block d-md-none "><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-2 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none"><b>Optional Subject</b></div>
                    <div class="col-6 pt-3 col-md-3">Mathematics</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Mode</b></div>
                    <div class="col-6 pt-3 col-md-3">Hybrid</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Starts on</b></div>
                    <div class="col-6 pt-3 col-md-3">10th Oct 2024</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Fee</b></div>
                    <div class="col-6 pt-3 col-md-3">8,000 (Old Students)<br/>8,000 (New Students)</div>
                    <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Upsc-IFoS-2024/IFOS-Maths-Test-Schedule-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 pb-2 d-block d-md-none "><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-2 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>
              
	      </div>
        </div>
        </div>
        </div>
</section> 


        <Footer />                      
        </>
    )
}
export default Two_Year_Classroom_Programme
